import moment from 'moment'

const getDate = (d) => {
    const date = moment(d, 'DD/MM/YYYY').isValid() ? moment(d, 'DD/MM/YYYY') : moment(d)
	if (d && date.isValid()) {
		return (
			date.format('DD/MM/YYYY')
		)
	}
	return ''
}

const getYear = (date) => {
	if (date) {
		return (
			moment(date).format('YYYY')
		)
	}
	return ''
}

export { getDate, getYear }



// WEBPACK FOOTER //
// ./src/utils/DateUtil.js